/* Control.tsx generated by @compiled/babel-plugin v0.36.1 */
import _extends from "@babel/runtime/helpers/extends";
import "./Control.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import { components } from '@atlaskit/select';
import { cx } from '@compiled/react';
var controlStyles = {
  invalid: "_1h6d1bqt _4cvx1bqt",
  focused: "_1h6d1p6i _bfhk1j9a _4cvx1p6i _irr31j9a",
  disabled: "_irr3syzs",
  subtle: "_1h6d1j28 _bfhk1j28 _4cvx1j28 _irr31gly",
  root: "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1h6d1elr _bfhk1j9a _p12f1osq _1fkdidpf _4cvx1elr _irr31d5g _1a98kb7n"
};
var Control = function Control(props) {
  return /*#__PURE__*/React.createElement(components.Control, _extends({}, props, {
    xcss: cx(controlStyles.root, (props.selectProps.subtle || props.selectProps.noBorder) && controlStyles.subtle, props.isFocused && controlStyles.focused, props.isInvalid && controlStyles.invalid, props.isDisabled && controlStyles.disabled)
  }));
};
export default Control;